import {
  SET_DASHBOARD,
  GET_DASHBOARD_REQUEST,
  DASHBOARD_CHANGE_OUTLET,
  DASHBOARD_CHANGE_DATE,
  DASHBOARD_SET_OUTLETS,
  DASHBOARD_PAGE_REQUEST
} from './constants'

export function setDashboard (data) {
  return {type: SET_DASHBOARD, payload: {dashboard: data}}
}

export function setOutlets (outlets) {
  return {type: DASHBOARD_SET_OUTLETS, payload: {outlets}}
}

export function getDashboardRequest (query) {
  return {type: GET_DASHBOARD_REQUEST, payload: {query}}
}

export function changeOutlet (outletIds, startDate, endDate) {
  return {type: DASHBOARD_CHANGE_OUTLET, payload: {outletIds, startDate, endDate}}
}

export function changeDate (startDate, endDate) {
  return {type: DASHBOARD_CHANGE_DATE, payload: {startDate, endDate}}
}

export function pageRequest () {
  return {type: DASHBOARD_PAGE_REQUEST, payload: {}}
}



// WEBPACK FOOTER //
// ./app/actions/dashboard/index.js